import { toFiniteNumber } from 'utils/math/math.utils';

const MINIMUM_LATITUDE = -90;
const MAXIMUM_LATITUDE = 90;
const MINIMUM_LONGITUDE = -180;
const MAXIMUM_LONGITUDE = 180;

/**
 * Converts latitude and longitude values into a valid Leaflet map position.
 * Numeric strings are accepted, while missing, non-numeric, and out-of-range
 * coordinates return null.
 *
 * @param {unknown} latitudeValue - Latitude in decimal degrees.
 * @param {unknown} longitudeValue - Longitude in decimal degrees.
 * @returns {[number, number]|null} Valid [latitude, longitude] position, or null.
 */
export const getValidMapPosition = (latitudeValue, longitudeValue) => {
  const latitude = toFiniteNumber(latitudeValue);
  const longitude = toFiniteNumber(longitudeValue);
  const hasValidLatitude =
    latitude !== null && latitude >= MINIMUM_LATITUDE && latitude <= MAXIMUM_LATITUDE;
  const hasValidLongitude =
    longitude !== null && longitude >= MINIMUM_LONGITUDE && longitude <= MAXIMUM_LONGITUDE;

  return hasValidLatitude && hasValidLongitude ? [latitude, longitude] : null;
};

/**
 * Reports whether an array contains a latitude and longitude that can be mapped.
 *
 * @param {unknown} position - Candidate [latitude, longitude] position.
 * @returns {boolean} Whether the position contains valid coordinates.
 */
export const isValidMapPosition = (position) =>
  Array.isArray(position) && getValidMapPosition(position[0], position[1]) !== null;
